// IMPORTS GO HERE
import _ from 'underscore';
import $ from 'jquery';
import { setElementsFromScope } from '../../utilities/selectorHelpers';
import render from '../../utilities/render';
require('./fileUploader.less');
const uploaderBodyHtml = require('./html/uploaderBody.html');
const fileNameRowHtml = require('./html/fileNameRow.html');

// rename to match what this component is...
export default function fileUploader(options = {}) {
  // functional code for component here
  let self = this;
  let defaults = {
    maxFileSize: 10
  }

  const setting = _.extend(defaults, options);
  const els = {};
  const elementsMap = {
    selectFileBtn: '.select-files-btn',
    mfuFileInput: '.mfu-file-input',
    fileNameRenderArea: '.file-name-render-area',
    fileNameRow: '.file-name-row'
  };
  const uploaderContainer = $(setting.target);

  let multiple = false;

  if (setting.multiple) {
    multiple = true;
  }

  let acceptedFileFormats = setting.accept || [];

  let fileFormatTextOnBody = (acceptedFileFormats.length > 0) ? acceptedFileFormats.join(" ").toUpperCase() : 'All file formats are accepted.';

  let fileFormatForAcceptAttr = (acceptedFileFormats.length > 0) ? acceptedFileFormats.join(",") : '';

  let maxFileSize = setting.maxFileSize;

  let fileMeta = null,
    fileList = [];

  self.init = function () {
    buildHtml();
    setElements();
    bindElements();
  }

  function buildHtml() {
    uploaderContainer.html(renderMultiFileUploader());
  }

  function renderMultiFileUploader() {
    return render(uploaderBodyHtml, {
      multiple,
      maxFileSize,
      fileFormat: fileFormatTextOnBody,
      accept: fileFormatForAcceptAttr
    });
  }

  function setElements() {
    setElementsFromScope(els, elementsMap, uploaderContainer);
  }

  function bindElements() {
    els.selectFileBtn.on('click', onSelectFileBtnClick);
    els.mfuFileInput.on('change', handleFileInputChange);
    uploaderContainer.on('click', '.file-remove-btn', handleRemoveBtnClick);
  }

  function onSelectFileBtnClick(e) {
    e.preventDefault();
    els.mfuFileInput.trigger('click');
  }

  function handleFileInputChange(e) {
    if (fileApiSupported()) {
      if (!multiple) {
        fileList = [];
      }
      fileMeta = e.target.files;
      if (fileList.length < 1) {
        fileList = Object.keys(fileMeta).map((key) => {
          return fileMeta[key]
        });
      } else {
        let newSelection = Object.keys(fileMeta).map((key) => {
          return fileMeta[key]
        });
        fileList = fileList.concat(newSelection);
      }
      //console.log(fileMeta);
      //console.log(fileList);
      renderSelectedFilesInRow(fileList);
    }
    else {
      alert("Your Browser is Vintage! File upload is not available on this old of a browser.");
    }
  }

  function fileApiSupported() {
    return !!(window.File && window.FileReader && window.FileList && window.Blob);
  }

  function renderSelectedFilesInRow(list) {
    const fileListHtml = (list).map((item, index) => {
      let ndx = index;
      let errorHtml, extension, hasError, isInvalidFileFormat;

      if (acceptedFileFormats.length > 0) {
        acceptedFileFormats = acceptedFileFormats.map(opt => opt.toUpperCase());
        extension = getFileExtension(item.name);
        isInvalidFileFormat = !_(acceptedFileFormats).contains(extension);
      }

      if (isInvalidFileFormat || isFileSizeAllowed(item.size)) {
        errorHtml = `<div class="q-alert q-alert-red q-marg-top-xs">File is too big or the wrong format. Please delete this file and reupload a corrected file.</div>`;
        hasError = 'has-error';
      }

      return render(fileNameRowHtml, {
        fileName: item.name,
        error: errorHtml,
        ndx,
        hasError
      });
    });

    els.fileNameRenderArea.html(fileListHtml.join(""));
    handleCallBacksAfterSelection();
  }

  function handleRemoveBtnClick(e) {
    e.preventDefault();
    let targetClosestEl = $(this).closest(".file-name-row");
    let indexToRemove = targetClosestEl.data('file-list-index');
    if (indexToRemove > -1) {
      fileList.splice(indexToRemove, 1);
    }
    renderSelectedFilesInRow(fileList);
  }

  function getFileExtension(name) {
    return `.${name.split('.').pop().toUpperCase()}`;
  }

  function isFileSizeAllowed(size) {
     return Math.ceil(size / 1000000) > maxFileSize;
  }

  function isSelectionValid() {
    if (els.fileNameRenderArea.children().length) {
      return !els.fileNameRenderArea.children().hasClass('has-error');
    }
  } 

  function handleCallBacksAfterSelection() {
    if (isSelectionValid()) {
      options.afterValidSelection && options.afterValidSelection();
    } else {
      options.afterInvalidSelection && options.afterInvalidSelection(fileList.length);
    }
  }

  self.getFiles = function () {
    if (isSelectionValid()) {
      return fileList;
    }
  }
};

export function photoUploader(options = {}) {
  // functional code for component here
  let self = this;
  let defaults = {
    maxFileSize: 10
  }

  const setting = _.extend(defaults, options);
  const els = {};
  const elementsMap = {
    selectFileBtn: '.select-files-btn',
    mfuFileInput: '.mfu-file-input',
    fileNameRenderArea: '.file-name-render-area',
    fileNameRow: '.file-name-row'
  };
  const uploaderContainer = $(setting.target);

  let multiple = false;

  if (setting.multiple) {
    multiple = true;
  }

  let acceptedFileFormats = setting.accept || [];

  let fileFormatTextOnBody = (acceptedFileFormats.length > 0) ? acceptedFileFormats.join(" ").toUpperCase() : 'All file formats are accepted.';

  let fileFormatForAcceptAttr = (acceptedFileFormats.length > 0) ? acceptedFileFormats.join(",") : '';

  let maxFileSize = setting.maxFileSize;

  let fileMeta = null,
    fileList = [];

  self.init = function () {
    buildHtml();
    setElements();
    bindElements();
  }

  function buildHtml() {
    uploaderContainer.html(renderMultiFileUploader());
  }

  function renderMultiFileUploader() {
    return render(uploaderBodyHtml, {
      multiple,
      maxFileSize,
      fileFormat: fileFormatTextOnBody,
      accept: fileFormatForAcceptAttr
    });
  }

  function setElements() {
    setElementsFromScope(els, elementsMap, uploaderContainer);
  }

  function bindElements() {
    els.selectFileBtn.on('click', onSelectFileBtnClick);
    els.mfuFileInput.on('change', handleFileInputChange);
    uploaderContainer.on('click', '.file-remove-btn', handleRemoveBtnClick);
  }

  function onSelectFileBtnClick(e) {
    e.preventDefault();
    els.mfuFileInput.trigger('click');
  }

  function handleFileInputChange(e) {
    if (fileApiSupported()) {
      if (!multiple) {
        fileList = [];
      }
      fileMeta = e.target.files;
      if (fileList.length < 1) {
        fileList = Object.keys(fileMeta).map((key) => {
          return fileMeta[key]
        });
      } else {
        let newSelection = Object.keys(fileMeta).map((key) => {
          return fileMeta[key]
        });
        fileList = fileList.concat(newSelection);
      }
      //console.log(fileMeta);
      //console.log(fileList);
      renderSelectedFilesInRow(fileList);
    }
    else {
      alert("Your Browser is Vintage! File upload is not available on this old of a browser.");
    }
  }

  function fileApiSupported() {
    return !!(window.File && window.FileReader && window.FileList && window.Blob);
  }

  function renderSelectedFilesInRow(list) {
    const fileListHtml = (list).map((item, index) => {
      let ndx = index;
      let errorHtml, extension, hasError, isInvalidFileFormat;

      if (acceptedFileFormats.length > 0) {
        acceptedFileFormats = acceptedFileFormats.map(opt => opt.toUpperCase());
        extension = getFileExtension(item.name);
        isInvalidFileFormat = !_(acceptedFileFormats).contains(extension);
      }

      if (isInvalidFileFormat || isFileSizeAllowed(item.size)) {
        errorHtml = `<div class="q-alert q-alert-red q-marg-top-xs">File is too big or the wrong format. Please delete this file and reupload a corrected file.</div>`;
        hasError = 'has-error';
      }

      return render(fileNameRowHtml, {
        fileName: item.name,
        error: errorHtml,
        ndx,
        hasError
      });
    });

    els.fileNameRenderArea.html(fileListHtml.join(""));
    handleCallBacksAfterSelection();
  }

  function handleRemoveBtnClick(e) {
    e.preventDefault();
    let targetClosestEl = $(this).closest(".file-name-row");
    let indexToRemove = targetClosestEl.data('file-list-index');
    if (indexToRemove > -1) {
      fileList.splice(indexToRemove, 1);
    }
    renderSelectedFilesInRow(fileList);
  }

  function getFileExtension(name) {
    return `.${name.split('.').pop().toUpperCase()}`;
  }

  function isFileSizeAllowed(size) {
    return (size / 1000000) > maxFileSize;
  }

  function isSelectionValid() {
    if (els.fileNameRenderArea.children().length) {
      return !els.fileNameRenderArea.children().hasClass('has-error');
    }
  } 

  function handleCallBacksAfterSelection() {
    if (isSelectionValid()) {
      options.afterValidSelection && options.afterValidSelection();
    } else {
      options.afterInvalidSelection && options.afterInvalidSelection(fileList.length);
    }
  }

  self.getFiles = function () {
    if (isSelectionValid()) {
      return fileList;
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/fileuploader/index.js